import React from 'react';
import {
  IconBike16,
  IconCar16,
  IconCompetitor16,
  IconInfrastructureScooter16,
  IconMapNoCar16,
  IconParking16,
  IconPolice16,
  IconWalk16,
} from '@cian/ui-kit';

import { IMapRowsProps } from '../../../../../components/Map/parts/MapRows';
import { EInsideTAInfrastructureType, ITAInfrastructure } from '../../../../../types/map';
import { getAvailableInsideInfrastructureTypes } from '../../../helpers/transportAccessibility';

const INFRASTRUCTURE_TYPE_TO_ROW_MAP: Record<
  EInsideTAInfrastructureType,
  {
    text: string;
    IconComponent: React.FunctionComponent;
  }
> = {
  [EInsideTAInfrastructureType.yardWithoutCars]: {
    text: 'Двор без машин',
    IconComponent: IconMapNoCar16,
  },
  [EInsideTAInfrastructureType.parking]: {
    text: 'Парковки',
    IconComponent: IconParking16,
  },
  [EInsideTAInfrastructureType.dropOffPickUpArea]: {
    text: 'Быстрая остановка',
    IconComponent: IconCar16,
  },
  [EInsideTAInfrastructureType.bikeParking]: {
    text: 'Велопарковки',
    IconComponent: IconBike16,
  },
  [EInsideTAInfrastructureType.chargingStations]: {
    text: 'Зарядки электромобилей',
    IconComponent: IconCompetitor16,
  },
  [EInsideTAInfrastructureType.scooterParking]: {
    text: 'Парковка самокатов',
    IconComponent: IconInfrastructureScooter16,
  },
  [EInsideTAInfrastructureType.boulevards]: {
    text: 'Пешеходные бульвары',
    IconComponent: IconWalk16,
  },
  [EInsideTAInfrastructureType.trafficSafetyElements]: {
    text: 'Безопасность движения',
    IconComponent: IconPolice16,
  },
};

export const getInsideRows = (transportAccessibilityInfrastructure: ITAInfrastructure | undefined) => {
  const { existingInfrastructureTypes, missingInfrastructureTypes } = getAvailableInsideInfrastructureTypes(
    transportAccessibilityInfrastructure,
  );

  const clickableRows: IMapRowsProps['items'] = existingInfrastructureTypes.map(type => ({
    id: type,
    ...INFRASTRUCTURE_TYPE_TO_ROW_MAP[type],
  }));

  const nonClickableRows: IMapRowsProps['items'] = missingInfrastructureTypes.map(type => ({
    id: type,
    ...INFRASTRUCTURE_TYPE_TO_ROW_MAP[type],
  }));

  return {
    clickableRows,
    nonClickableRows,
  };
};
